export const typeList = {
  img: /\.(gif|jpg|jpeg|png|webp|svg|GIF|JPG|JPEG|PNG|WEBP|SVG)/,
  video: /\.(swf|avi|flv|mpg|rm|mov|wav|asf|3gp|mkv|rmvb|ogg|mp4)/,
  audio: /\.(mp3|wav|MP3|WAV)/,
  iframe: /\.(pdf|PDF|doc|DOC|docx|DOCX|xls|xlsx|txt)/,
  words: /pdf|PDF|doc|DOC|docx|DOCX|xls|xlsx|txt/,
};

